import { View } from 'react-native'
import { colors } from '@ui/colors'
import Skeleton from '@ui/elements/Skeleton'
import {
  borderRadius,
  height as heightOrderHistory,
} from '@order/OrderHistory/styles'

export default function Loading() {
  const style = {
    height: 112,
    backgroundColor: colors.neutral[200],
    borderRadius,
  }

  return (
    <View className="flex flex-col gap-8 px-8">
      <Skeleton
        className="w-full"
        style={{
          ...style,
          height: heightOrderHistory,
        }}
      />
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton className="w-full" style={style} key={index} />
      ))}
    </View>
  )
}
